import { request } from "../../../app/api-client/ApiClient";

/**
 * Obtiene las preguntas y respuestas asociadas a una estación EVBI por su IMEI
 * Las preguntas incluyen opciones para filtros dinámicos (Empresa, Área, Cargo)
 * @param {function} dispatch - Dispatch de Redux
 * @param {string} imei - IMEI de la estación (obtenido de modulos[0].imei)
 * @returns {Promise<Array>} Array de preguntas con respuestas
 * 
 * @example
 * const preguntas = await getPreguntasByImei(dispatch, '123456789');
 * // Retorna:
 * // [
 * //   {
 * //     id: 5,
 * //     pregunta: "Empresa contratante",
 * //     orden: 1,
 * //     respuestas: [
 * //       { id: 9, respuesta: "(COMER) Comercializadora Nal. SAS", siguiente: 6 },
 * //       { id: 10, respuesta: "(PAC) Pepsico Alimentos Antioquia LTDA", siguiente: 6 }
 * //     ]
 * //   },
 * //   { id: 6, pregunta: "Área", orden: 2, respuestas: [...] },
 * //   { id: 7, pregunta: "Cargo", orden: 3, respuestas: [...] }
 * // ]
 */
export function getPreguntasByImei(dispatch, imei) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/pregunta/evbi/${imei}`,
		method: "GET",
	}, dispatch);
}
